<table mat-table [dataSource]="promocodesDataSource" matSort multiTemplateDataRows matSortActive="id"
    matSortDirection="asc" (matSortChange)="announceSortChange($event)">
    <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="r-5pc-column r-th">#</th>
        <td mat-cell *matCellDef="let code" class="r-5pc-column r-no-bottom-border"> {{code.id}} </td>
    </ng-container>
    <ng-container matColumnDef="code">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="r-th">Code</th>
        <td mat-cell *matCellDef="let code" class="r-no-bottom-border"> {{code.code}} </td>
    </ng-container>
    <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="r-th">Description</th>
        <td mat-cell *matCellDef="let code" class="r-no-bottom-border">
            @if (code.active) {
            {{code.description}}

            } @else {
            {{code.description}}
            }
        </td>
    </ng-container>
    <ng-container matColumnDef="discountRate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="r-th">Discount value</th>
        <td mat-cell *matCellDef="let code" class="r-no-bottom-border"> {{code | discountValue}} </td>
    </ng-container>
    <ng-container matColumnDef="validUntil">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="r-th">Valid until</th>
        <td mat-cell *matCellDef="let code" class="r-no-bottom-border">
            @if (code.isExpired()) { <span class="r-text-red">{{code.validUntil | date: 'dd/MM/yyyy'}}</span>
            } @else {
            <span class="r-text-green">{{code.validUntil | date: 'dd/MM/yyyy'}}</span>
            }
    </ng-container>
    <ng-container matColumnDef="uses">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="r-th">#Uses</th>
        <td mat-cell *matCellDef="let code" class="r-no-bottom-border">
            <span [ngClass]="{'r-text-green': (code.uses < code.maxUses) || (code.maxUses == 0), 
            'r-text-red': (code.uses >= code.maxUses) && (code.maxUses != 0)}">
                {{code.uses}}
            </span>
        </td>
    </ng-container>
    <ng-container matColumnDef="maxUses">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="r-th">Max uses</th>
        <td mat-cell *matCellDef="let code" class="r-no-bottom-border"> {{code.maxUses}} </td>
    </ng-container>
    <ng-container matColumnDef="active">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="r-th">Active?</th>
        <td mat-cell *matCellDef="let code" class="r-no-bottom-border">
            @if (code.active) {
            <mat-icon color="primary" style="color: green" title="Active">check_circle </mat-icon>
            } @else {
            <mat-icon color="warn" style="color: red;" title="Inactive">cancel</mat-icon>
            }
        </td>
    </ng-container>
    <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="r-th">Actions </th>
        <td mat-cell *matCellDef="let code" class="r-no-bottom-border">
            <button mat-icon-button color="primary" title="Copy code to clipboard" (click)="copyCodeToClipboard(code)"
                disabled="false">
                <mat-icon>content_copy</mat-icon>
            </button>
            <button mat-icon-button color="primary" title="Edit" (click)="editCode(code)" [disabled]="code.uses > 0">
                <mat-icon>edit</mat-icon>
            </button>
            @if (code.active) {
            <button mat-icon-button color="primary" title="Disable" (click)="toggleCode(code)">
                <mat-icon>cancel</mat-icon>
            </button>
            } @else {
            <button mat-icon-button color="primary" title="Enable" (click)="toggleCode(code)">
                <mat-icon>check_circle</mat-icon>
            </button>}
            <button mat-icon-button color="primary" title="Delete" (click)="deleteCode(code)"
                [disabled]="code.uses > 0">
                <mat-icon>delete</mat-icon>
            </button>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"></tr>

    <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="4">No data available</td>
    </tr>
</table>

<mat-paginator #codePaginator [pageSize]="pageSize" [pageIndex]="pageIndex" [pageSizeOptions]="pageSizeOptions"
    [showFirstLastButtons]="showFirstLastButtons">
</mat-paginator>

<div
    style="display: flex; flex-direction: row; justify-content: center; gap: 10px; padding-top: 10px; padding-bottom: 10px;">
    <button matFab extended color="primary" title="Add a code" (click)="addCode()">
        <mat-icon>add</mat-icon>Add code
    </button>

    <button matFab extended color="primary" title="Generate a batch of codes" (click)="generateCodes()">
        <mat-icon fontIcon="">playlist_add</mat-icon>Generate codes
    </button>
</div>